import React from 'react'

import * as HoverCard from '@radix-ui/react-hover-card'

import useTranslation from '../../context/hooks/useTranslation'
import InfoSquareIcon from '../../vectors/InfoSquareIcon'

export interface ShipmentInfoButtonProps {
  onClick: () => void
}

export const ShipmentInfoButton: React.FC<ShipmentInfoButtonProps> = ({
  onClick,
}) => {
  const { t } = useTranslation()

  return (
    <HoverCard.Root openDelay={200} closeDelay={0}>
      <HoverCard.Trigger asChild>
        <button
          type="button"
          onClick={onClick}
          className="hover:bg-gray-34 flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-sm"
        >
          <InfoSquareIcon />
        </button>
      </HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content
          side="right"
          className="font-body shadow-elevation-2 rounded-sm bg-indigo-50 p-2 text-xs text-white"
        >
          {t('RETURNS_SCAN.MORE_DETAILS')}
          <HoverCard.Arrow className="fill-indigo-50" />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}

export default ShipmentInfoButton
